"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const RecordingsTable_1 = __importDefault(require("@Components/ViewWork/RecordingsTable"));
const recording_1 = require("@App/api/routes/recording");
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const ViewWorkSection_1 = __importDefault(require("@Components/ViewWork/ViewWorkSection"));
const axios_1 = __importDefault(require("axios"));
const recording_to_recordingmodel_1 = require("@App/helpers/recording-to-recordingmodel");
const Sidebar_1 = require("@Components/Sidebars/Sidebar");
const DownloadSidebar_1 = require("@Components/Sidebars/DownloadSidebar");
const sidebar_download_type_1 = require("@App/enum/sidebar-download-type");
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const MatchedRecordingsSection = (props) => {
    const PAGE_LIMIT = 10;
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [currentPage, setCurrentPage] = (0, react_1.useState)(1);
    const [totalRecordings, setTotalRecordings] = (0, react_1.useState)(0);
    const [recordingPage, setRecordingPage] = (0, react_1.useState)([]);
    const [sidebarIsOpen, setSidebarIsOpen] = (0, react_1.useState)(false);
    const closeSidebar = () => {
        setSidebarIsOpen(false);
    };
    const { work } = props;
    const handlePage = (pagination) => {
        var _a, _b;
        setLoading(true);
        const newPage = (_a = pagination.page) !== null && _a !== void 0 ? _a : 1;
        setCurrentPage(newPage);
        (0, recording_1.getDspRecordingsForSongCode)((_b = work.songCode) !== null && _b !== void 0 ? _b : '', pagination)
            .then((axiosResult) => {
            setTotalRecordings(axiosResult.data.count);
            setRecordingPage(axiosResult.data.recordings.map(recording_to_recordingmodel_1.mapRecordingToRecordingModel));
        })
            .catch((error) => {
            if (axios_1.default.isAxiosError(error)) {
                if ('Error: No recordings match that song code.' !== error.message) {
                    throw error;
                }
            }
        })
            .finally(() => setLoading(false));
    };
    (0, react_1.useEffect)(() => {
        handlePage({ page: currentPage, limit: PAGE_LIMIT });
    }, []);
    return (react_1.default.createElement(ViewWorkSection_1.default, { icon: 'recordings', title: 'Matched Recordings', count: totalRecordings },
        loading ? (react_1.default.createElement(PointPreloader_1.default, null)) : (react_1.default.createElement(RecordingsTable_1.default, { recordings: recordingPage, totalRecordings: totalRecordings, currentPage: currentPage, handlePage: handlePage, recordingType: 'matched' })),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: sidebarIsOpen, onClose: closeSidebar },
            react_1.default.createElement(Sidebar_1.Sidebar, { onClose: closeSidebar },
                react_1.default.createElement(DownloadSidebar_1.DownloadSidebar, { closeSidebar: closeSidebar, sidebarDownloadType: sidebar_download_type_1.SidebarDownloadType.MatchedRecordingsExport })))));
};
exports.default = MatchedRecordingsSection;
